<script setup>
import locales from '@/common/locales'
import { formatDayMin, get, post, toJson, validators } from '@/common/util'
import { useEntityStructureStore, useMetaStore } from '@/stores'
import _ from 'lodash-es'
import { reactive, Teleport,ref } from 'vue'
import { useI18n } from 'vue-i18n'
import ManMemDetail from './ManMemDetail.vue'
import { onBeforeRouteUpdate } from 'vue-router'
import { useRouter,useRoute } from 'vue-router'
const props=defineProps({isadm:{type:Boolean,required:false}}),ess=useEntityStructureStore(),metaStore=useMetaStore()
,i18n=useI18n(),router=useRouter(),route=useRoute(),manmemdetail=ref(null)
,meta=reactive({cols:['authorities','disabled','mid','mname','contact','email','company','cdt'],tblheight:400
  ,modmeminfo:[{col:'disabled',modelValue:false},{col:'mid',mandatory:true,holderkey:'pleaseenteryourid'},{col:'email',mandatory:true,holderkey:'pleaseenteryouremail'}
    ,{col:'etc',modelValue:'forceauth'},{col:'mname',mandatory:true,holderkey:'enteraname'},{col:'company',holderkey:'pleaseenteryourcompanyperiodname'}
    ,{col:'contact',holderkey:'pleaseenteryourpriorityphoneorcellphonenumber'},{col:'dept',holderkey:'pleaseenteradepartmentname'}
    ,{col:'jobtitle',holderkey:'pleaseenteryourjobtitle'},{col:'localecode',modelValue:_.find(locales,{'key':'ko-KR'})}]
  ,search:{},page:1,size:20,isasc:false,sortcol:'cdt',admtargets:[],midmnames:[]})
,search=async(callback=()=>{})=>{
  metaStore.blockLoading()
  const where=_.pickBy(meta.search,val=>!_.isEmpty(val))
  if(props.isadm)where.authorities='ADMIN'
  const res=await post('rest/authed/admin/searchmem',{where:where,page:meta.page,size:meta.size,isasc:meta.isasc,sortcol:meta.sortcol})
  metaStore.blockLoading(false)
  meta.loading=false
  meta.data=res.data
  meta.tblheight=window.innerHeight-320
  if(meta.tblheight<=0)meta.tblheight=200
  try{
    callback()
  }catch(e){}
},sort=(col)=>{
  if(col==meta.sortcol)meta.isasc=!meta.isasc
  meta.sortcol=col
  search()
},pop=async(type,mid)=>{
  if(type=='unadm')meta.selmid=mid
  if(type=='setadm'){
    meta.admtargets=[]
    const res=await post('rest/authed/admin/simplemems',{authorities:'MEMBER'})
    meta.midmnames=_.entries(res.data).map(ent=>({mid:ent[0],mname:ent[1]}))
  }
  meta.poptype=type
  meta.popto=null
  if(meta.poptype=='mod'){
    meta.modmeminfo.forEach(mi=>mi.modelValue=meta.selmem[mi.col])
    meta.modmeminfo.find(mi=>mi.col=='etc').modelValue=''
  }
  const isaddmod=['add','mod'].includes(meta.poptype),callback=()=>{
    metaStore.pop({ison:true,persist:isaddmod,callback:() =>{
      document.querySelector('#popbody').style.width=meta.poptype=='log'?(document.querySelector('.v-overlay').offsetWidth*.9)+'px':''
      meta.popto='#popbody'
    }})
  }
  if(isaddmod)get('rest/authed/member/jobttls',res=>{
      meta.jobttls=_.orderBy(res.data,'ord','asc').map(jt=>jt.nm)
      get('rest/authed/member/depts',res=>{
        meta.depts=res.data.map(dept=>dept.nm)
        callback()
      })
    })
  else callback()
},isValidMem=()=>meta.modmeminfo.filter(mi=>mi.mandatory).every(mi=>validators.required(mi.modelValue)===true)
  &&validators.email(meta.modmeminfo.find(mmi=>mmi.col=='email').modelValue)===true
,closePop=()=>{
  meta.selmid=meta.popto=meta.poptype=null
  metaStore.pop({ison:false})
},modMem=async()=>{
  meta.confirmpop=false
  meta.modloading=true
  let pd={}
  if(meta.selmem)pd=toJson(meta.selmem)
  meta.modmeminfo.forEach(mmi=>pd[mmi.col]=mmi.modelValue)
  pd.localecode=pd.localecode.key
  const res=await post('rest/authed/admin/'+meta.poptype+'mem',pd)
  if(!res.isSuccess){
    meta.modloading=false
    return metaStore.toastKey(res.msg,res.isSuccess)
  }
  metaStore.toastKey('savesuccessful')
  if(meta.poptype=='add'){
    meta.data=null
    meta.search={}
  }else{
    const mid=meta.selmem.mid
    const afterSearch=()=>{
        meta.selmem=null
        setTimeout(()=>{
          meta.selmem=meta.data.rows.find(row=>row.mid==mid)
        },10)
    }
    search(afterSearch)
  }
  meta.modloading=meta.confirmpop=false
  closePop()
},delMem=async()=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/delmem',meta.selmem)
  metaStore.blockLoading(false)
  metaStore.toastKey(res.isSuccess?'thedeletioniscomplete':'deletefailed',res.isSuccess)
  if(res.isSuccess){
    meta.selmem=null
    search()
  }
},terminateAdm=async()=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/tglmemauth',{mid:meta.selmid,authorities:'MEMBER'})
  metaStore.blockLoading(false)
  meta.selmid=null
  search()
  metaStore.toastKey(res.isSuccess?'processed':'unprocessed',res.isSuccess)
},toMemDetail=async(mid)=>{
  meta.selmem=await get('rest/authed/admin/mem/'+mid)
  meta.selmem=meta.selmem.data
  router.push({hash: '#detail'})
},putAdm=async()=>{
  if(meta.admtargets.length==0)return metaStore.toastKey('sel_tar_con',false)
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/setadm',meta.admtargets.map(adm=>adm.mid))
  metaStore.blockLoading(false)
  search()
}
ess.ensureItem('member',ms=>{
  meta.struct=ms
  ms.disabled.tkey='useraccess'
  meta.modmeminfo.forEach(mi=>mi.tkey=ms[mi.col].tkey)
})
onBeforeRouteUpdate((to, from) => {
  if(!to.hash||to.hash=='')meta.selmem=null
})

</script>
<template>
  <v-card flat v-if="!meta.selmem">
    <v-card-title class="d-flex align-center pe-2">
      <v-row>
        <v-col cols="3">{{ $t(isadm?'adm_list':'mem_list')+' '+$t('searchresults') }}</v-col>
        <v-spacer/>
        <v-col v-for="svar in [{key:'mname',tkey:'name'},{key:'contact',tkey:'contact'},{key:'email',tkey:'email'}]">
          <v-text-field v-model="meta.search[svar.key]" density="compact" :label="$t(svar.tkey)" variant="solo-filled" flat hide-details :width="svar.key=='email'?200:''"/>
        </v-col>
        <v-col>
          <v-btn prepend-icon="mdi-magnify" color="secondary" @click="search">{{ $t('search') }}</v-btn>
        </v-col>
        <v-col v-if="metaStore.dispmode!='minimum'||(metaStore.dispmode=='minimum'&&isadm)" class="text-right">
          <v-btn color="primary" @click.stop="pop(props.isadm?'setadm':'add')">{{ $t('newregistration') }}</v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-sheet>
      <v-table v-if="meta.struct" fixed-header :height="meta.tblheight">
        <thead>
          <tr>
            <th class="text-left cursor-pointer" v-for="col in meta.cols" @click="meta.data&&sort(col)">
              {{ $t(meta.struct[col].tkey) }}
              <v-icon v-if="meta.data&&col==meta.sortcol" :icon="meta.isasc?'mdi-arrow-up':'mdi-arrow-down'"/>
            </th>
            <th>{{ $t('viewdetails') }}</th>
            <th v-if="props.isadm">
              {{ $t('unadm') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-center" v-if="!meta.data||!meta.data.rows.length">
            <td :colspan="meta.cols.length+(props.isadm?2:1)">{{ $t('noresultsfound')+' '+$t('pleaseconfirmyoursearchterm') }}</td>
          </tr>
          <tr v-else v-for="row in meta.data.rows">
            <td v-for="col in meta.cols">
              <div v-if="col=='authorities'">{{ $t(row[col]) }}</div>
              <div v-else-if="col=='disabled'">{{ $t(row[col]===false?'accessible':'oinaccessible') }}</div>
              <div v-else-if="col=='cdt'">{{ formatDayMin(row[col]) }}</div>
              <div v-else>{{ row[col] }}</div>
            </td>
            <td>
              <v-btn :text="$t('viewdetails')" @click="toMemDetail(row.mid)"/>
            </td>
            <td v-if="props.isadm">
              <v-btn color="error" :text="$t('termination')" @click="pop('unadm',row.mid)"/>
            </td>
          </tr>
        </tbody>
      </v-table>
      <v-row justify="center" class="mt-5">
        <v-col>
          <v-pagination v-if="meta.data" :length="meta.data.totalPages" :total-visible="meta.data.pageCount" v-model="meta.page" @update:model-value="search"/>
        </v-col>
      </v-row>
    </v-sheet>
  </v-card>
  <ManMemDetail ref="manmemdetail" v-else :mem="meta.selmem" @to-list="meta.selmem=null;router.push({hash: ''});search()" @mod="pop('mod')" @del="pop('del')"/>
  <Teleport v-if="meta.popto" :to="meta.popto">
    <v-card v-if="['add','mod'].includes(meta.poptype)" class="mx-auto" min-width="340" :title="$t(meta.poptype=='add'?'manuallyenrollusers':'editmemberinformation')">
      <v-container>
        <v-row no-gutters v-for="mmi in meta.modmeminfo">
          <v-col class="mb-2">
            <v-switch v-if="mmi.col=='disabled'" color="primary" :label="$t(mmi.tkey)" hide-details :model-value="!mmi.modelValue" @update:model-value="val=>mmi.modelValue=!val"/>
            <v-select v-else-if="mmi.col=='localecode'" hide-details density="compact" variant="outlined" :label="$t('userlang')" :items="locales" item-title="val" item-value="key"
              :model-value="mmi.modelValue" @update:model-value="val=>mmi.modelValue=val"/>
            <v-sheet flat class="mb-3" v-else-if="mmi.col=='etc'">
              <div class="text-subtitle-2">{{ $t('temporarypasswords') }} *</div>
              <v-radio-group inline hide-details v-model="mmi.modelValue">
                <v-radio v-if="meta.selmem" :label="$t('nochangeyourpassword')" value=""/>
                <v-radio :label="$t('sendingemail')" value="sendpasswd"/>
                <v-radio :label="$t('createnew')" value="forceauth"/>
              </v-radio-group>
            </v-sheet>
            <v-combobox v-else-if="['dept','jobtitle'].includes(mmi.col)" hide-details density="compact" variant="outlined" :label="$t(mmi.tkey)"
              :items="mmi.col=='dept'?meta.depts:meta.jobttls" :model-value="mmi.modelValue" @update:model-value="val=>mmi.modelValue=val" :placeholder="$t(mmi.holderkey)"/>
            <v-text-field v-else density="compact" :disabled="meta.poptype=='mod'&&mmi.col=='mid'" v-model="mmi.modelValue" :hide-details="!mmi.mandatory" :label="$t(mmi.tkey)+(mmi.mandatory?' *':'')"
              variant="outlined" :rules="[mmi.mandatory?validators.required:true,mmi.col=='email'?validators.email:true]" :placeholder="$t(mmi.holderkey)"/>
          </v-col>
        </v-row>
      </v-container>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn variant="outlined" :text="$t('cancel')" @click="closePop"/>
        <v-btn variant="elevated" color="primary" :text="$t('save')" :disabled="!isValidMem()" @click="meta.confirmpop=true"/>
      </v-card-actions>
      <v-overlay contained class="align-center justify-center" v-model="meta.confirmpop">
        <v-card class="mx-auto" min-width="340" :title="$t(meta.poptype=='add'?'manuallyenrollusers':'editmemberinformation')">
          <v-divider/>
          <v-card-text>
            {{$t('save_con')}}
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn :text="$t('cancel')" variant="outlined" @click="meta.confirmpop=false"/>
            <v-btn :text="$t('confirm')" class="ms-2 me-3" variant="outlined" color="primary" @click="modMem"/>
          </v-card-actions>
        </v-card>
      </v-overlay>
      <v-overlay :model-value="meta.modloading" class="align-center justify-center" persistent>
        <v-progress-circular color="primary" size="64" indeterminate/>
      </v-overlay>
    </v-card>
    <v-card v-else-if="meta.poptype=='del'" class="mx-auto" min-width="340" :title="$t('withdrawal')+' '+$t('confirm')">
      <v-divider/>
      <v-card-text>
        <div class="text-h6 mb-2">{{ $t('attention') }}</div>
        <div>{{$t('knowwhatinformationisdeletedretainedwhenyouunsubscribeoncedeleteditcantberecovered')}}</div>
        <ul class="ma-5">
          <li v-for="tk in ['deleteaccountinformation','deleteinquiryhistory','deletemynotes','deleteasharedlayer']">
            {{ $t(tk) }}
          </li>
        </ul>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn :text="$t('cancel')" variant="outlined" @click="closePop"/>
        <v-btn :text="$t('confirm')" class="ms-2 me-3" variant="outlined" color="primary" @click="delMem"/>
      </v-card-actions>
    </v-card>
    <v-card v-else-if="meta.poptype=='unadm'" class="mx-auto" min-width="340" :title="$t('unadm')">
      <v-divider/>
      <v-card-text>
        <div class="mb-2">{{ $t('unadm_mem_detail') }}</div>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn :text="$t('cancel')" variant="outlined" @click="closePop"/>
        <v-btn :text="$t('confirm')" class="ms-2 me-3" variant="outlined" color="primary" @click="terminateAdm"/>
      </v-card-actions>
    </v-card>
    <v-card v-else-if="meta.poptype=='setadm'" class="mx-auto" min-width="360">
      <v-card-title>
        <v-row>
          <v-col>{{ $t('addanadmin') }}</v-col>
          <v-col class="text-right">
            <v-btn density="compact" icon="mdi-close" @click="closePop"/>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <div>{{ $t('checkitout') }}</div>
        <div>{{ $t('adminscanbeaddedafterregularsignup') }}</div>
        <div>{{ $t('youcanaddupto10usersatatime') }}</div>
        <v-combobox max-width="400" variant="outlined" class="mt-5" v-model="meta.admtargets" :items="meta.midmnames" :label="$t('sel_mem')" :item-title="val=>val.mname+`(${val.mid})`" item-value="mid" chips multiple
          @update:model-value="selusers=>{
            const filtered=selusers.filter(item => typeof item !== 'string')
            if(filtered.length>10){
              metaStore.toast('최대 10명까지 등록 가능합니다.',false)
              filtered.splice(10)
            }
            meta.admtargets=filtered
          }"/>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn :text="$t('cancel')" variant="outlined" @click="closePop"/>
        <v-btn :text="$t('confirm')" class="ms-2 me-3" variant="outlined" color="primary" @click="putAdm"/>
      </v-card-actions>
    </v-card>
  </Teleport>
</template>
